module.exports = __webpack_public_path__ + "Metronic_fda1334c35d0f5fe2afb3afebbb6774a.2d5f15f92161454f1e3c.eot";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/metronic/Metronic_fda1334c35d0f5fe2afb3afebbb6774a.eot
// module id = ../../../../../src/assets/vendors/base/fonts/metronic/Metronic_fda1334c35d0f5fe2afb3afebbb6774a.eot
// module chunks = styles